import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getLocalStorageItem } from "../Utils";
import ErrorBoundary from "./ErrorBoundry";
function PublicAuth(props) {
  const isAuthenticated = () => {
    const user = getLocalStorageItem("accessToken");
    return user;
  };
  const userDetail = getLocalStorageItem("userDetail");
  return isAuthenticated() ? (
    <>
      <Navigate to={userDetail.is_kyc === "0" ? "/kyc" : "/dashboard"} />
    </>
  ) : (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
}
export default PublicAuth;
